import Layout from '@/components-new/layout.vue'
import Header from '@/components-new/header.vue'
import Img from './components-new/img.vue'
import Avatar from './components-new/avatar.vue'
import Switch from './components-new/switch.vue'
import Loading from './components/loading'
import EmptyData from './components/empty-data'
import PullRefreshSlot from './components/pull-refresh-slot'

export default {
  install (Vue) {
    Vue.component('fps-layout', Layout)
    Vue.component('fps-header', Header)
    Vue.component('fps-img', Img)
    Vue.component('fps-avatar', Avatar)
    Vue.component('fps-switch', Switch)
    Vue.component('fps-loading', Loading)
    Vue.component('fps-empty', EmptyData)
    Vue.component('fps-pull-refresh', PullRefreshSlot)
  },
}
